import { styled } from 'styled-components';
import { Action } from '../../Action';
export const AlertBannerTextButton = styled(Action).withConfig({
  componentId: "aui__sc-1fe62iu-0"
})(["line-height:1.5;padding:0;white-space:break-spaces;color:currentColor;", " &:not(:disabled):hover,&:not(:disabled):active{cursor:pointer;color:currentColor;}"], ({
  $isBesideDismissButton
}) => $isBesideDismissButton && `margin-right: -.5rem;`);